import { render, staticRenderFns } from "./BoostedRevenue.vue?vue&type=template&id=8ffbee64&"
import script from "./BoostedRevenue.vue?vue&type=script&lang=ts&"
export * from "./BoostedRevenue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports